import { ChevronRightIcon } from '@chakra-ui/icons';
import { Box, Image, Heading, Text, useToast, Skeleton, Button } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useMutation } from 'react-query';
import { getAssessmentReport, startAssessmentBlockItem } from '../../../../apis/V2/assessment';
import { useAssessmentToken } from '../../../../context/AssessmentTokenContext';
import { Link, useNavigate } from 'react-router-dom';
import { AxiosError } from 'axios';
import { UIErrorResponse } from '../../../../../../../packages/types/src/error';
import Lottie from 'react-lottie-player';
import successLottie from '../../../assets/lottie/successLottie.json';
import { SAGEX_ORG_KEY } from '../../../../utils/segexOrgName';
import { useDomainConfig } from '../../../../hooks/useDomainConfig';
const AssessmentItemCard = ({
	userAssessment,
	blockItemId,
	assessmentType,
	meta,
}: {
	userAssessment: any;
	blockItemId: string;
	meta: any;
	assessmentType: string;
}) => {
	const data = {
		title: meta?.title,
		noOfQuestions: meta?.noOfQuestions,
		companyLine: meta?.companyLine,

		companyLogo: meta?.companyLogo || '',
	};
	const navigate = useNavigate();
	const { data: domainConfig, isLoading, isError } = useDomainConfig({ uiHost: window.location.host });

	const { assessmentToken, setAssessmentToken, setRedirectionPath } = useAssessmentToken();
	const toast = useToast();

	const { mutate: startAssessmentMutate, isLoading: startAssessmentLoading } = useMutation(startAssessmentBlockItem, {
		onSuccess: response => {
			console.log('response----:', response.data.userAssessment.token);
			setAssessmentToken(response.data.userAssessment.token);
			setRedirectionPath(window.location.pathname + window.location.search);
			// redirect to assessment page
			navigate(`/dashboard/block-item/${blockItemId}/assessment/start`);
		},
		onError: (error: AxiosError<UIErrorResponse>) => {
			console.log('error:', error);
			toast({
				title: 'Error',
				description: error?.response?.data?.message || 'Unable to start assessment, please try again!',
				status: 'error',
				duration: 2000,
				isClosable: true,
				position: 'top',
			});
		},
	});

	const { mutate: getAssessmentReportMutate, isLoading: getAssessmentReportLoading } = useMutation(getAssessmentReport, {
		onSuccess: data => {
			// console.log('Data:---------', data?.data?.reportUrl);
			// @ts-ignore
			const reportUrl = data?.data?.reportUrl;
			console.log('reportUrl:', reportUrl);
			// fetch report url
			if (reportUrl) {
				window.location.href = reportUrl || '';
			} else {
				toast({
					title: 'Error',
					description: "Submission token doesn't exist!",
					status: 'error',
					duration: 2000,
					isClosable: true,
					position: 'top',
				});
			}
		},
		onError: (error: AxiosError<UIErrorResponse>) => {
			toast({
				title: 'Error',
				description: error?.response?.data?.message || 'Report failed',
				status: 'error',
				duration: 2000,
				isClosable: true,
				position: 'top',
			});
		},
	});
	const { isKnowYourLevelAssessmentGiven } = useAssessmentToken();
	return (
		<>
			<Skeleton isLoaded={!startAssessmentLoading}>
				<Box
					cursor="pointer"
					onClick={() => {
						if (isKnowYourLevelAssessmentGiven || SAGEX_ORG_KEY === domainConfig?.key) {
							if (userAssessment?.assessmentStatus === 'COMPLETED' || userAssessment?.assessmentStatus === 'GRADED') {
								getAssessmentReportMutate({ blockItemId });
							} else {
								startAssessmentMutate({ blockItemId });
							}
						} else {
							// TODO: show modal
						}
					}}
					maxW="361px"
					borderRadius={'16px'}
					boxShadow={'0px 1px 2px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)'}
				>
					<Image position={'absolute'} src="/images/block-item-card.svg" />
					<Box>
						<Box display={'flex'} textAlign={'center'} alignItems={'center'} minH="148px" bgColor={'#5039E0'} borderTopRadius={'16px'}>
							<Heading as="h3" color="#fff" maxW="90%" mx="auto">
								{data?.title}
							</Heading>
						</Box>
						<Box
							display={'flex'}
							alignItems={'center'}
							justifyContent={'space-between'}
							borderTop="#E5E5E5"
							borderBottomRadius={'16px'}
							p="10px"
							bgColor={'#FFF'}
						>
							<Box>
								{data?.companyLogo && (
									<Box display={'flex'} alignItems={'center'}>
										<Text textStyle={'body1-md'}>{data?.companyLine}</Text>
										<Image ml="4px" h='20px' src={data?.companyLogo} alt="company" />
										{/* {data?.companyLogos?.map((logo: any) => (
								<Image ml="4px" src="https://masai-website-images.s3.ap-south-1.amazonaws.com/company_logo_9a3dcbc061.svg" />
							))} */}
									</Box>
								)}
								{!(userAssessment?.assessmentStatus === 'GRADED' || userAssessment?.assessmentStatus === 'COMPLETED') && (
									<Box mt="2px">
										<Text display={'inline'} textStyle={'body2'}>
											No. of questions:{' '}
										</Text>
										<Text display={'inline'} textStyle={'body2-md'}>
											{data?.noOfQuestions}
										</Text>
									</Box>
								)}
							</Box>

							{userAssessment?.assessmentStatus === 'GRADED' || userAssessment?.assessmentStatus === 'COMPLETED' ? (
								<Box w="64px" mx="auto" p={''}>
									<Lottie loop animationData={successLottie} play style={{ width: '100%' }} />
								</Box>
							) : (
								<Image src="/images/right-arrow.svg" />
							)}
						</Box>
					</Box>
					{userAssessment?.assessmentStatus === 'GRADED' || userAssessment?.assessmentStatus === 'COMPLETED' ? (
						<Box display={'flex'} justifyContent={'space-between'} mt="-16px" p="10px" color="ms-purple.500">
							{userAssessment?.assessmentStatus === 'GRADED' && (
								<Text ml="8px" display={'inline'}>
									Score: {userAssessment?.leaderboardWeightage}/{userAssessment?.totalMaxMarks}
								</Text>
							)}
							<Text display={'inline'} textDecoration={'underline'}>
								View Submission
							</Text>
						</Box>
					) : null}
				</Box>
			</Skeleton>
		</>
	);
};

export default AssessmentItemCard;
